var exports = {
  "ST": "FavoritesChannelListContent.module__channelBadgeSelected___UF9iYU",
  "pJ": "FavoritesChannelListContent.module__channelBadgeSelectedIcon___UF9iYU",
  "Vm": "FavoritesChannelListContent.module__favoriteItemContainer___UF9iYU",
  "eb": "FavoritesChannelListContent.module__favoriteItem___UF9iYU",
  "bu": "FavoritesChannelListContent.module__favoriteItemDefault___UF9iYU",
  "Vb": "FavoritesChannelListContent.module__favoriteItemSelected___UF9iYU",
  "q6": "FavoritesChannelListContent.module__favoriteItemOver___UF9iYU",
  "xQ": "FavoritesChannelListContent.module__favoriteItemMuted___UF9iYU",
  "H": "FavoritesChannelListContent.module__avatarContainer___UF9iYU",
  "my": "FavoritesChannelListContent.module__avatar___UF9iYU",
  "rZ": "FavoritesChannelListContent.module__avatarPlaceholder___UF9iYU",
  "XQ": "FavoritesChannelListContent.module__channelBadge___UF9iYU",
  "gg": "FavoritesChannelListContent.module__channelBadgeIcon___UF9iYU",
  "QC": "FavoritesChannelListContent.module__displayName___UF9iYU",
  "Hq": "FavoritesChannelListContent.module__actionsContainer___UF9iYU",
  "af": "FavoritesChannelListContent.module__categoryItem___UF9iYU",
  "Yq": "FavoritesChannelListContent.module__categoryContent___UF9iYU",
  "yb": "FavoritesChannelListContent.module__categoryName___UF9iYU",
  "Yl": "FavoritesChannelListContent.module__categoryIcon___UF9iYU",
  "wp": "FavoritesChannelListContent.module__categoryActions___UF9iYU",
  "Ef": "FavoritesChannelListContent.module__hoverAffordance___UF9iYU",
  "It": "FavoritesChannelListContent.module__categoryAddButton___UF9iYU",
  "n3": "FavoritesChannelListContent.module__categoryAddButtonIcon___UF9iYU",
  "NP": "FavoritesChannelListContent.module__navigationContainer___UF9iYU",
  "r0": "FavoritesChannelListContent.module__channelGroupsContainer___UF9iYU",
  "kj": "FavoritesChannelListContent.module__uncategorizedGroup___UF9iYU",
  "Mn": "FavoritesChannelListContent.module__keyboardFocus___UF9iYU",
};

module.exports = exports;
